import React, { FC } from 'react';
import { Outlet } from 'react-router';

const Books: FC = () => <Outlet />;

export default Books;
